import React from "react";
import Helmet from "react-helmet";

export default () => (
	<div className="page-wrapper">
		<Helmet title={`Contact - My Awesome Site`} />
		<section className="contact-hero">
	    	<h1>Please don't contact us</h1>
	  	</section>
	  	<section className="page-inner">
	  		<div className="container">
	  			<div className="contact-left">
		  			<h2>We'd rather sleep</h2>
		  			<p>
		  				Our days are jammed packed with naps, video games, long lunches, and a little actual work sprinkled in there somewhere. Our work is so optimized we can pack in some 8 hours of work into about 2 or 3 hours, then we get out there and live life with the rest of our day.
		  			</p>
		  			<p>
		  				But if for some reason you got the impression that we are a compnay you want to work with, go right ahead and fill out this form.
		  			</p>
		  		</div>
		  		<div className="contact-right">
		  			<form action="" method="get">
		  				<fieldset>
		  					<div className="form-row">
		  						<label for="contact-name">Name</label>
		  						<input type="text" id="contact-name" />
		  					</div>
		  					<div className="form-row">
		  						<label for="contact-email">Email</label>
		  						<input type="email" id="contact-email" />
		  					</div>
		  					<div className="form-row">
		  						<label for="contact-message">Message</label>
		  						<textarea id="contact-message"></textarea>
		  					</div>	
		  					<div className="form-row webline">
		  						<label for="contact-website">Website</label>
		  						<input type="text" id="contact-website" />
		  					</div>
		  					<div className="form-row">
		  						<input type="submit" id="contact-submit" value="Submit" />
		  					</div>
		  				</fieldset>
		  			</form>
		  		</div>
	  		</div>
	  	</section>
  	</div>
);


// WEBPACK FOOTER //
// ./src/pages/contact.js